import { Translations } from '../translations';
import { Component, Inject } from '@angular/core';
import { FirebaseService } from '@ppl/firebase';
import { I18nService } from '@ppl/i18n';
import { PplIconService } from '@ppl/ui/icon';
import { DEPLOY_URL } from '@ppl/utils/injection-tokens';

@Component({
    selector: 'ppl-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  constructor(
    @Inject(DEPLOY_URL) private deployUrl: string,
    private pplIconService: PplIconService,
    private firebaseService: FirebaseService,
    private i18nService: I18nService
  ) {
    this.pplIconService.registerPplIcons(this.deployUrl);
    this.i18nService.registerTranslations(Translations);
    this.firebaseService.init();
  }
}
